// ** Redux Imports
import { createSlice } from '@reduxjs/toolkit'

// ** UseJWT import to get config
import useJwt from '@src/auth/jwt/useJwt'

const config = useJwt.jwtConfig

const initialUser = () => {
  try {
    const item = window.localStorage.getItem('userData')

    // If nothing stored, return empty object
    if (!item) return {}

    const trimmed = item.trim()

    // Guard against non-JSON values like empty string or 'undefined'
    if (!trimmed || trimmed === 'undefined' || trimmed === 'null') return {}

    return JSON.parse(trimmed)
  } catch (err) {
    console.warn('Unable to parse userData from localStorage:', err)
    try {
      window.localStorage.removeItem('userData')
    } catch (e) {
      // ignore
    }
    return {}
  }
}

export const authSlice = createSlice({
  name: 'authentication',
  initialState: {
    loading: false,
    userData: initialUser()
  },
  reducers: {
    handleLogin: (state, action) => {
      state.userData = action.payload
      state[config.storageTokenKeyName] =
        action.payload[config.storageTokenKeyName]
      state[config.storageRefreshTokenKeyName] =
        action.payload[config.storageRefreshTokenKeyName]
      localStorage.setItem('userData', JSON.stringify(action.payload))
      localStorage.setItem(
        config.storageTokenKeyName,
        action.payload.accessToken,
        action.payload.userName,
        action.payload.role,
        action.payload.id
      )
      localStorage.setItem(
        config.storageRefreshTokenKeyName,
        action.payload.refreshToken
      )
    },

    handleLogout: (state) => {
      state.userData = {}
      state[config.storageTokenKeyName] = null
      state[config.storageRefreshTokenKeyName] = null
      // ** Remove user, accessToken & refreshToken from localStorage
      localStorage.removeItem('userData')
      localStorage.removeItem(config.storageTokenKeyName)
      localStorage.removeItem(config.storageRefreshTokenKeyName)
      localStorage.removeItem('redirectBackUrl')
      localStorage.removeItem('ntts_ui_filter_cache')
      try {
        window.sessionStorage.removeItem('ntts_return_url')
      } catch (e) {
        // ignore
      }
    }
  }
})

export const { handleLogin, handleLogout, handleProfileData } =
  authSlice.actions

export default authSlice.reducer
